import { render, staticRenderFns } from "./TabbedContentComponent.vue?vue&type=template&id=27a837e5&scoped=true"
import script from "./TabbedContentComponent.vue?vue&type=script&lang=js"
export * from "./TabbedContentComponent.vue?vue&type=script&lang=js"
import style0 from "./TabbedContentComponent.vue?vue&type=style&index=0&id=27a837e5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27a837e5",
  null
  
)

export default component.exports